<template>
  <header class="superior">
    <h2>{{ titulo }}</h2>
    <div class="derecha">
      <NotificacionesCampana v-if="auth.autenticado" />
      <img src="@/assets/udi-logo.png" alt="UDI Logo" class="logo-superior" />
    </div>
  </header>
</template>

<script lang="ts" setup>
/**
 * Barra superior: identidad del usuario, notificaciones y salida.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import NotificacionesCampana from '@/components/NotificacionesCampana.vue'
import useAutenticar from '@/store/IngresoAutenticar'

const route = useRoute()
const auth = useAutenticar()

const titulos: Record<string, string> = {
  Inicio: 'Inicio',
  ListaVersiones: 'Versiones',
  CrearModelo: 'Gestión de Modelos',
  AgregarComponente: 'Agregar Componentes',
  PresentarDocumento: 'Documento del Modelo',
  ModeloCompleto: 'Modelo Completo',
  EstructuraModelo: 'Estructura del Modelo',
  Pesos: 'Gestión de Pesos',
  AgregarIndicadores: 'Indicadores',
  Instrumento: 'Instrumentos',
  FichaDocumental: 'Ficha Documental',
  FichaEstadistica: 'Ficha Estadística',
  FichaOpinion: 'Ficha de Opinión',
  GestionRubricas: 'Gestión de Rúbricas',
  ListaCalificar: 'Calificar Instrumentos',
  InstrumentoDetalle: 'Detalle del Instrumento',
  AsignarRoles: 'Asignar Roles',
  SubirEvidencias: 'Evidencias',
  EvidenciasInstrumentos: 'Evidencias de Instrumentos',
  AsignarEvaluadores: 'Asignar Evaluadores',
  EvaluacionIndividual: 'Evaluación Individual',
  ResultadosConsolidados: 'Resultados Consolidados',
  AuditoriaEvaluaciones: 'Auditoría',
  EvaluacionExpertos: 'Evaluación por Expertos',
  Dashboard: 'Dashboard',
  Calendario: 'Calendario de Acreditación',
  AvanceProceso: 'Avance del Proceso',
  SeguimientoPlan: 'Seguimiento del Plan',
  Trazabilidad: 'Trazabilidad',
  PlanMejoramiento: 'Plan de mejoramiento y fortalecimiento'
}

const titulo = computed(() => {
  const nombre = route.name as string
  return titulos[nombre] ?? 'Modelos'
})
</script>

<style scoped>
.superior {
  height: 64px;
  background-color: white;
  color: black;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--space-lg);
  font-family: var(--font-family);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  z-index: 10;
}

.logo-superior {
  height: 36px;
  width: auto;
}

.derecha {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.superior h2 {
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  flex: 1;
  min-width: 0;
  overflow: visible;
  white-space: normal;
  word-break: break-word;
}

.tabs-container {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 0.5rem;
}

.tab {
  padding: 0.5rem 1.25rem;
  margin-left: 0.5rem;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-weight: 500;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.tab:hover {
  color: #0e69a0;
}

.tab.active {
  border-bottom: 2px solid #0e69a0;
  color: #0e69a0;
}
</style>
